import React from 'react';
import { Text, View, TextInput, StyleSheet } from 'react-native';

import OPComponent from '../op_component';
import { COLOR, FONT, FONT_SIZE, THEME } from '../../../constants/styles';

export default class FormTextArea extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {
      value: '',
    };

    this.textAreaRef = React.createRef();
  }

  focus() {
    this.textAreaRef.current?.focus();
  }

  handleChangeText = (text) => {
    if (this.props.onChangeText) this.props.onChangeText(text);

    this.setState({ value: text });
  };

  render() {
    let { value, tipText, placeholder, maxLength } = this.props;

    let hasTip = !!tipText || maxLength > 0;

    return (
      <View>
        <TextInput
          ref={this.textAreaRef}
          style={[styles.textArea, this.props.style]}
          defaultValue={value || ''}
          multiline={true}
          maxLength={maxLength}
          placeholder={placeholder}
          placeholderTextColor={COLOR.textLight}
          numberOfLines={this.props.numberOfLines}
          selectTextOnFocus={false}
          autoCorrect={false}
          autoCapitalize="none"
          underlineColorAndroid="transparent"
          onChangeText={this.handleChangeText}
        />
        {hasTip && (
          <View style={styles.tipContainer}>
            {!!tipText && <Text style={styles.tipText}>{tipText}</Text>}
            {maxLength > 0 && (
              <Text style={styles.tipText}>
                {this.state.value.length}/{maxLength}
              </Text>
            )}
          </View>
        )}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  textArea: Object.assign({}, THEME.input, {
    height: 130,
    paddingHorizontal: 5,
    backgroundColor: COLOR.altContrast,
    borderTopLeftRadius: 3,
    borderTopRightRadius: 3,
    borderBottomWidth: 2,
    borderBottomColor: COLOR.textLight,
  }),
  tipContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
    marginBottom: 30,
  },
  tipText: {
    ...FONT.regular,
    fontSize: FONT_SIZE.tiny,
    color: COLOR.textLight,
  },
});
